<template>
  <div>
    <!-- fleet logo card -->
    <FleetLogoCard class="mt-10 mx-8" />
    <!-- fleet locations list -->
    <LocationsPage />
  </div>
</template>
<script setup lang="ts">
import FleetLogoCard from "../my-fleet/FleetLogoCard.vue";
import LocationsPage from "./LocationsPage.vue";
</script>
<style scoped></style>
